import { styled } from '@mui/material'
import Button from 'components/Button'

export const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.surface.A900,
  background: theme.palette.surface[50],
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '&:hover': {
    background: theme.palette.surface[50],
    color: theme.palette.surface.A900,
    filter: 'none',
  },
}))
